/* MANIERE · extras de la ficha completa (mn-ficha): flechas y deslizar en la
   galeria, foto por color y fecha de entrega. El carrito y las variantes los
   sigue llevando mn-tienda.js. */
(function () {
  if (window.__mnFicha) return;
  window.__mnFicha = true;

  var marca = function (el) {
    if (!el || el.dataset.mnF) return false;
    el.dataset.mnF = '1';
    return true;
  };

  /* ---------- galería: ir a una foto concreta ---------- */
  function irA(galeria, i) {
    var fotos = galeria.querySelectorAll('.mn-pdp__foto');
    if (!fotos.length) return;
    var n = fotos.length;
    i = ((i % n) + n) % n;
    fotos.forEach(function (f) {
      f.classList.toggle('mn-on', f.dataset.mnFoto === String(i));
    });
    var minis = galeria.querySelector('[data-mn-minis]');
    galeria.querySelectorAll('.mn-pdp__mini').forEach(function (m) {
      var on = m.dataset.mnMini === String(i);
      m.classList.toggle('mn-on', on);
      /* la miniatura activa, a la vista dentro de su fila (sin mover la pagina) */
      if (on && minis) {
        var izq = m.offsetLeft - (minis.clientWidth - m.clientWidth) / 2;
        minis.scrollTo({ left: Math.max(0, izq), behavior: 'smooth' });
      }
    });
    var cont = galeria.querySelector('[data-mn-contador]');
    if (cont) cont.textContent = i + 1 + ' / ' + n;
  }

  function actual(galeria) {
    var on = galeria.querySelector('.mn-pdp__foto.mn-on');
    return on ? parseInt(on.dataset.mnFoto, 10) || 0 : 0;
  }

  function initGaleria() {
    document.querySelectorAll('[data-mn-ficha] [data-mn-galeria]').forEach(function (g) {
      if (!marca(g)) return;

      g.querySelectorAll('[data-mn-flecha]').forEach(function (b) {
        b.addEventListener('click', function () {
          irA(g, actual(g) + parseInt(b.dataset.mnFlecha, 10));
        });
      });

      /* el contador tambien sigue a las miniaturas (esas las lleva mn-tienda.js) */
      g.querySelectorAll('.mn-pdp__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          var cont = g.querySelector('[data-mn-contador]');
          var n = g.querySelectorAll('.mn-pdp__foto').length;
          if (cont) cont.textContent = parseInt(m.dataset.mnMini, 10) + 1 + ' / ' + n;
        });
      });

      /* deslizar con el dedo */
      var escena = g.querySelector('[data-mn-escena]');
      if (!escena) return;
      var x0 = null;
      var y0 = null;
      escena.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      escena.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          irA(g, actual(g) + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    });
  }

  /* ---------- foto por color ----------
     mn-tienda.js avisa con 'mn:variante' cada vez que cambia la eleccion (y
     una vez al arrancar). Justo antes ha llevado la galeria a la foto de la
     variante; si el color elegido tiene su foto asignada, esa manda.
     El aviso del arranque se ignora: al entrar se ve la primera foto de la
     galeria (la de portada), no la del color. */
  var tocado = false;
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-mn-ficha] .mn-pdp__ov')) tocado = true;
  }, true);
  document.addEventListener('mn:variante', function () {
    if (!tocado) return;
    document.querySelectorAll('[data-mn-ficha]').forEach(function (ficha) {
      var elegido = ficha.querySelector('.mn-pdp__ov.mn-on[data-mn-fotocolor]');
      var g = ficha.querySelector('[data-mn-galeria]');
      if (elegido && g) irA(g, parseInt(elegido.dataset.mnFotocolor, 10));
    });
  });

  /* ---------- fecha de entrega ---------- */
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
    'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function sumar(dias, laborables) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    if (!laborables) {
      d.setDate(d.getDate() + dias);
      return d;
    }
    var n = 0;
    while (n < dias) {
      d.setDate(d.getDate() + 1);
      var s = d.getDay();
      if (s !== 0 && s !== 6) n++;
    }
    return d;
  }

  function initEntrega() {
    document.querySelectorAll('[data-mn-entrega]').forEach(function (el) {
      if (!marca(el)) return;
      var hueco = el.querySelector('[data-mn-fechas]');
      if (!hueco) return;
      var lab = el.dataset.mnLaborables === '1';
      var a = sumar(parseInt(el.dataset.mnMin || '0', 10), lab);
      var b = sumar(parseInt(el.dataset.mnMax || '0', 10), lab);
      if (b < a) { var t = a; a = b; b = t; }
      var txt;
      if (a.getTime() === b.getTime()) {
        txt = 'el ' + a.getDate() + ' de ' + MESES[a.getMonth()];
      } else if (a.getMonth() === b.getMonth()) {
        txt = 'entre el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()];
      } else {
        txt = 'entre el ' + a.getDate() + ' de ' + MESES[a.getMonth()] +
          ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()];
      }
      hueco.textContent = txt;
    });
  }

  /* ---------- cinta de fotos: pausa al tocarla en el movil ---------- */
  function initCinta() {
    document.querySelectorAll('[data-mn-cinta]').forEach(function (c) {
      if (!marca(c)) return;
      c.addEventListener('touchstart', function () {
        c.classList.toggle('mn-pausa');
      }, { passive: true });
    });
  }

  /* ---------- carrusel de opiniones: flechas ---------- */
  function initOpiniones() {
    document.querySelectorAll('[data-mn-opiniones]').forEach(function (o) {
      if (!marca(o)) return;
      var pista = o.querySelector('[data-mn-pista]');
      if (!pista) return;
      var paso = function () {
        var tarjeta = pista.querySelector('.mn-opi__c');
        var gap = parseFloat(getComputedStyle(pista).columnGap || getComputedStyle(pista).gap || '0') || 0;
        return tarjeta ? tarjeta.getBoundingClientRect().width + gap : pista.clientWidth * 0.8;
      };
      var ant = o.querySelector('[data-mn-opi="-1"]');
      var sig = o.querySelector('[data-mn-opi="1"]');
      var pintar = function () {
        var max = pista.scrollWidth - pista.clientWidth - 2;
        if (ant) ant.disabled = pista.scrollLeft <= 2;
        if (sig) sig.disabled = pista.scrollLeft >= max;
      };
      [ant, sig].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function () {
          pista.scrollBy({ left: paso() * parseInt(b.dataset.mnOpi, 10), behavior: 'smooth' });
        });
      });
      pista.addEventListener('scroll', function () {
        window.requestAnimationFrame(pintar);
      }, { passive: true });
      window.addEventListener('resize', pintar);
      pintar();
    });
  }

  function initTodo() {
    initGaleria();
    initEntrega();
    initCinta();
    initOpiniones();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();
